import Vue from "vue";
import Vuex from "vuex";

const Cerfa = {
    namespaced: true,
    state: {
        cerfaSelected: {},
        cerfa14024: {
            previousPermission: null,
            previousPermissionReference: null,
            workDescription: null,
            durationRegulation: null,
            dateRegulation: null,
            restrictionSuspenders: null,
            directionTraffic: null,
            alternatingCirculationManual: null,
            moveCar: null,
            moveTruck: null,
            parkCar: null,
            parkTruck: null,
            overtakeCar: null,
            overtakeTruck: null,
            limitedSpeed: null,
            detourRoute: null,
            otherPrescriptions: null,
            emergencyRestriction: null,
            encroachmentRoadway: null,
            numberWayRemoved: null,
            trackWidthMaintained: null,
            gestSignageCorporation: null,
            gestSignageFirstName: null,
            gestSignageLastName: null,
            gestSignageCorporationName: null,
            gestSignageCorporationSiret: null,
            gestSignageCorporationAgentTitle: null,
            gestSignageCorporationAgent: null,
            gestSignageAddressNum: null,
            gestSignageAddressExt: null,
            gestSignageAddressType: null,
            gestSignageAddressName: null,
            gestSignageAddressPlace: null,
            gestSignageAddressCity: null,
            gestSignageAddressPostalCode: null,
            gestSignagePhone: null,
            gestSignagePhoneIndicative: null,
            gestSignageEmail: null,
            isFavorable: null,
            commentDecision: null,
        },
        cerfa14023: {
            installationConnection: null,
            installationFencesAlignment: null,
            installationFencesBackAlignment: null,
            installationGateAlignment: null,
            installationGateBackAlignment: null,
            installationPlantationAlignment: null,
            installationPlantationBackAlignment: null,
            natureWork: "autres",
            parkingExtension: null,
            parkingPermit: null,
            parkingNature: null,
            trackWidth: null,
            sidewalkWidth: null,
            protrusionWidth: null,
            heightUnderProtrusion: null,
            ditchCrossing: null,
            pipeDiameter: null,
            pipeLength: null,
            distanceFromRoad: null,
            typePipe: null,
            layoutWidth: null,
            newInstallation: null,
            networkConnection: null,
            longitudinalTrenchUnderRoad: null,
            transverseTrenchUnderRoad: null,
            drivingUnderRoad: null,
            longitudinalTrenchUnderSidewalks: null,
            transverseTrenchUnderSidewalks: null,
            drivingUnderSidewalks: null,
            surfacePlanningEquipment: null,
            parkingNatureOther: null,
            networkConnectionOther: null,
            surfacePlanningEquipmentOther: null,
            themes: "ouvrage_divers",
            workProjectDeclaration: null,
            teleServiceNumber: null,
            digitalPlanningDeclaration: null,
            ftth: null,
            pipelineDepositLength: null,
            pipelinePoseLength: null,
            pipelineDepositTotalLength: null,
            pipelinePoseTotalLength: null,
            pipelinePoseNumber: null,
            pipelineDepositNumber: null,
            buriedCableDepositLength: null,
            buriedCableDepositNumber: null,
            buriedCablePoseLength: null,
            buriedCablePoseTotalLength: null,
            buriedCableDepositTotalLength: null,
            buriedCablePoseNumber: null,
            airArteryDepositLength: null,
            airArteryPoseLength: null,
            cupboardsNumberDeposit: null,
            cupboardsSurfDeposit: null,
            cupboardsNumberPose: null,
            cupboardsSurfPose: null,
            pavilionBollardNumberDeposit: null,
            pavilionBollardNumberPose: null,
            pavilionBollardSurfPose: null,
            pavilionBollardSurfDeposit: null,
            poleNumberDeposit: null,
            poleNumberPose: null,
            undergroundChamberNumberDeposit: null,
            undergroundChamberNumberPose: null,
            customePipeDiameter: null,
            contactLastName: null,
            contactFirstName: null,
            contactPhone: null,
            contactFax: null,
            contactNumFolder: null,
            contactEmail: null,
            isFavorable: null,
            commentDecision: null,
        },
    },
    actions: {
        initCerfa14023(context) {
            return new Promise((resolve, reject) => {
                let cerfa = {
                    installationConnection: null,
                    installationFencesAlignment: null,
                    installationFencesBackAlignment: null,
                    installationGateAlignment: null,
                    installationGateBackAlignment: null,
                    installationPlantationAlignment: null,
                    installationPlantationBackAlignment: null,
                    natureWork: "autres",
                    parkingExtension: null,
                    parkingPermit: null,
                    parkingNature: null,
                    trackWidth: null,
                    sidewalkWidth: null,
                    protrusionWidth: null,
                    heightUnderProtrusion: null,
                    ditchCrossing: null,
                    pipeDiameter: null,
                    pipeLength: null,
                    distanceFromRoad: null,
                    typePipe: null,
                    layoutWidth: null,
                    newInstallation: null,
                    networkConnection: null,
                    longitudinalTrenchUnderRoad: null,
                    transverseTrenchUnderRoad: null,
                    drivingUnderRoad: null,
                    longitudinalTrenchUnderSidewalks: null,
                    transverseTrenchUnderSidewalks: null,
                    drivingUnderSidewalks: null,
                    surfacePlanningEquipment: null,
                    parkingNatureOther: null,
                    networkConnectionOther: null,
                    surfacePlanningEquipmentOther: null,
                    themes: "ouvrage_divers",
                    workProjectDeclaration: null,
                    teleServiceNumber: null,
                    digitalPlanningDeclaration: null,
                    ftth: null,
                    pipelineDepositLength: null,
                    pipelinePoseLength: null,
                    pipelineDepositTotalLength: null,
                    pipelinePoseTotalLength: null,
                    pipelinePoseNumber: null,
                    pipelineDepositNumber: null,
                    buriedCableDepositLength: null,
                    buriedCableDepositNumber: null,
                    buriedCablePoseLength: null,
                    buriedCablePoseTotalLength: null,
                    buriedCableDepositTotalLength: null,
                    buriedCablePoseNumber: null,
                    airArteryDepositLength: null,
                    airArteryPoseLength: null,
                    cupboardsNumberDeposit: null,
                    cupboardsSurfDeposit: null,
                    cupboardsNumberPose: null,
                    cupboardsSurfPose: null,
                    pavilionBollardNumberDeposit: null,
                    pavilionBollardNumberPose: null,
                    pavilionBollardSurfPose: null,
                    pavilionBollardSurfDeposit: null,
                    poleNumberDeposit: null,
                    poleNumberPose: null,
                    undergroundChamberNumberDeposit: null,
                    undergroundChamberNumberPose: null,
                    customePipeDiameter: null,
                    contactLastName: null,
                    contactFirstName: null,
                    contactPhone: null,
                    contactFax: null,
                    contactNumFolder: null,
                    contactEmail: null,
                    datePreliminaryVisit: null,
                    isPreliminaryVisit: null,
                    numberCpce: null,
                    dateCpce: null,
                    isCpce: null
                }

                context.commit("SETCERFA14023", cerfa);
                resolve()

            })
        },
        setCerfa14024(context, cerfa) {
            return new Promise((resolve, reject) => {
                context.commit("SETCERFA14024", cerfa);
                resolve()
            })
        },
        setCerfa14023(context, cerfa) {
            return new Promise((resolve, reject) => {
                context.commit("SETCERFA14023", cerfa);
                resolve()
            })
        },
        initCerfa14024(context) {
            return new Promise((resolve, reject) => {
                let cerfa = {
                    previousPermission: null,
                    previousPermissionReference: null,
                    workDescription: null,
                    durationRegulation: null,
                    dateRegulation: null,
                    restrictionSuspenders: null,
                    directionTraffic: null,
                    alternatingCirculationManual: null,
                    moveCar: null,
                    moveTruck: null,
                    parkCar: null,
                    parkTruck: null,
                    overtakeCar: null,
                    overtakeTruck: null,
                    limitedSpeed: null,
                    detourRoute: null,
                    otherPrescriptions: null,
                    emergencyRestriction: null,
                    encroachmentRoadway: null,
                    numberWayRemoved: null,
                    trackWidthMaintained: null,
                    gestSignageCorporation: null,
                    gestSignageFirstName: null,
                    gestSignageLastName: null,
                    gestSignageCorporationName: null,
                    gestSignageCorporationSiret: null,
                    gestSignageCorporationAgentTitle: null,
                    gestSignageCorporationAgent: null,
                    gestSignageAddressNum: null,
                    gestSignageAddressExt: null,
                    gestSignageAddressType: null,
                    gestSignageAddressName: null,
                    gestSignageAddressPlace: null,
                    gestSignageAddressCity: null,
                    gestSignageAddressPostalCode: null,
                    gestSignagePhone: null,
                    gestSignagePhoneIndicative: null,
                    gestSignageEmail: null,
                }

                context.commit("SETCERFA14024", cerfa);
                resolve()
            })
        },
        addCerfa14023(context, cerfa) {

            for (const [key, value] of Object.entries(cerfa)) {
                if (value == "") {
                    cerfa[key] = null;
                }
            }
            return new Promise((resolve, reject) => {
                Vue.axios.post(window.urlapi + "cerfa14023", cerfa).then(
                    response => {
                        if (response.data.success == false) {
                            resolve(null);
                        }
                        else {
                            resolve(response.data.data)
                        }
                    },
                    failure => {
                        resolve(null);
                    }
                );
            })
        },

        updateCerfa14023(context, cerfa) {
            console.log(cerfa);
            for (const [key, value] of Object.entries(cerfa)) {
                if (value == "") {
                    cerfa[key] = null;
                }
            }
            console.log(cerfa);
            return new Promise((resolve, reject) => {
                Vue.axios.put(window.urlapi + "cerfa14023/" + cerfa.id, cerfa).then(
                    response => {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                        resolve(response.data.data)
                    },
                );
            })
        },

        addCerfa14024(context, cerfa) {
            for (const [key, value] of Object.entries(cerfa)) {
                if (value == "") {
                    cerfa[key] = null;
                }
            }
            return new Promise((resolve, reject) => {
                Vue.axios.post(window.urlapi + "cerfa14024", cerfa).then(
                    response => {
                        if (response.data.success == false) {
                            resolve(null);
                        }
                        else {
                            resolve(response.data.data)
                        }
                    },
                    failure => {
                        resolve(null);
                    }
                );
            })
        },

        updateCerfa14024(context, cerfa) {
            for (const [key, value] of Object.entries(cerfa)) {
                if (value == "") {
                    cerfa[key] = null;
                }
            }
            return new Promise((resolve, reject) => {
                Vue.axios.put(window.urlapi + "cerfa14024/" + cerfa.id, cerfa).then(
                    response => {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                        resolve(response.data.data)
                    },
                );
            })
        },

        getCerfa(context, payload) {
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "cerfa" + payload.type + "/" + payload.id).then(
                    response => {
                        context.commit("GETCERFA", response.data.data);
                        resolve();
                    },
                );
            })
        }
    },
    mutations: {
        GETCERFA: (state, cerfa) => {
            state.cerfaSelected = cerfa;
        },
        SETCERFA14023: (state, cerfa) => {
            state.cerfa14023 = cerfa
        },
        SETCERFA14024: (state, cerfa) => {
            state.cerfa14024 = cerfa
        },
    },
    getters: {
        cerfaSelected: state => {
            return state.cerfaSelected;
        },
        cerfa14023: (state, cerfa) => {
            return state.cerfa14023
        },
        cerfa14024: (state, cerfa) => {
            return state.cerfa14024
        },
    },
    modules: {}
};

export default Cerfa;